import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStepBack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStepBack"><Path d="M6.5 3.5L3.5 6.5L6.5 9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4 6.5H14.5C17.8137 6.5 20.5 9.18629 20.5 12.5C20.5 15.8137 17.8137 18.5 14.5 18.5H5.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconStepBack;
